import React, { useEffect, useContext } from 'react'
import { useNavigate } from "react-router";
import { requestLogout } from "../services/session/session-requests";
import { AppContext } from "../context/app-context";
import { toast } from "react-toastify";

const Logout = () => {
  const appContext = useContext(AppContext);
  const { user, clearUser, loadingUserDetails } = appContext;

  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.id) {
      const result = requestLogout();
      if (result) {
        result
          .then(() => {
            toast.success("Logged Out");
            clearUser();
            navigate("/");
          })
          .catch(() => navigate("/login?loggedOut=true"));
      }
    } else if (!loadingUserDetails) {
      navigate("/");
    }
  }, [loadingUserDetails, navigate, clearUser, user]);

  return <div/>;
};

export default Logout;
